<template>
  <div class="pageFooter">
    <div class="footzs">
      <div class="bg">
        <div class="footerList">
          <span style="margin-right: 40px"
            >版权所有：西藏自治区人力资源和社会保障厅专业技术人员管理处</span
          >
          <span>技术支持：四川铁猴教育管理有限公司</span>
        </div>
      </div>
      <div class="beianRuleBox">
        <a
          style="
            margin-right: 20px;
            text-decoration: none;
            color: rgb(107, 107, 107);
          "
          >蜀ICP备2024113986号-3 </a
        ><a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51012202002031"
          style="
            display: flex;
            align-items: center;
            text-decoration: none;
            color: rgb(107, 107, 107);
          ">
          <img
            src="@/assets/beian.png"
            style="width: 15px" />川公网安备51012202002031号</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getMenu } from "@/api/cms.js";
export default {
  data() {
    return {
      options1Value: "x0",
      options2Value: "x0",
      options1: [
        { value: "x0", label: "校内链接" },
        { value: "https://jjx.gzdzxy.cn/", label: "现代服务与旅游" },
        { value: "https://jjx.gzdzxy.cn/", label: "电子信息工程" },
        { value: "https://jjx.gzdzxy.cn/", label: "智能制造系" },
        { value: "https://jjx.gzdzxy.cn/", label: "汽车应用技术" },
        { value: "https://jjx.gzdzxy.cn/", label: "计算机与大数据" },
        { value: "https://jjx.gzdzxy.cn/", label: "中专部" },
      ],
      options2: [
        { value: "x0", label: "友情链接" },
        { value: "http://www.people.com.cn/", label: "人民网" },
        { value: "https://www.gaxq.gov.cn/", label: "贵安新区官网" },
        { value: "https://www.chinanews.com/", label: "中国新闻网" },
        { value: "https://tv.cctv.com/", label: "央视网" },
        { value: "https://news.sina.com.cn/", label: "新浪网" },
      ],
      list: [],
    };
  },
  methods: {
    handleUrl(val) {
      window.open(val);
      this.options1Value = "x0";
      this.options2Value = "x0";
    },
  },
};
</script>

<style lang="scss" scoped>
.beianRuleBox {
  padding: 20px 0;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.qrcode {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
  background: #ccc;
}
.main2 {
  width: 1200px;
  margin: 0 auto;
  font-weight: 400;
  font-size: 16px;
  padding-bottom: 20px;
  color: #4a4a4a;
}
.line {
  width: 1200px;
  height: 2px;
  margin: 0 auto;
  border-bottom: 1px solid #e1e1e1;
  margin-bottom: 20px;
  .line2 {
    width: 50px;
    height: 5px;
    background: #0d6fc2;
  }
}
.pageFooter {
  width: 100vw;
  // 阴影
  .main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    // margin-bottom: 20px;
    .left {
      .title {
        font-size: 18px;
        height: 60px;
        line-height: 60px;
        margin-bottom: 20px;
        a {
          margin-right: 20px;
          width: 100px;
          // 去a标签掉下划线
          text-decoration: none;
        }
      }
      .text {
        font-weight: 400;
        font-size: 16px;
        color: #4a4a4a;
        margin-bottom: 16px;
      }
    }
    .right {
      .selectAll {
        margin-bottom: 20px;
      }
    }
  }
}
.footzs {
  height: 68px;
  margin-bottom: 20px;
  .bg {
    height: 90px;
    background: #2f465c;
  }
}
.footerList {
  padding-top: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  width: 1400px;
  margin: 0 auto;
  font-size: 18px;
  color: #ffffff;
  .footerItem {
    a {
      padding-left: 10px;
    }
  }
}
</style>
